import api from '../api/client';
import jspdf from 'jspdf'
import 'jspdf-autotable'
import { vazirFont } from '../assets/fonts/vazir-font-v18.0.0/Vazir'
import { titrFont } from '../assets/fonts/Titr/Titr'
import { mitraFont } from '../assets/fonts/Mitra/Mitra'
import { Encoder, ErrorCorrectionLevel } from '@nuintun/qrcode';
import { gregorianToJalali, thousandsSeparate, toFarsiDigits } from '../assets/utils'
import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { addPdfFooter } from '../assets/reportFooter'

const printDocumentTransfer = async (encrypted_qrcode) => {
    // If encrypted_qrcode ends in '/', remove it
    if (encrypted_qrcode.endsWith('/')) {
        encrypted_qrcode = encrypted_qrcode.substring(0, encrypted_qrcode.length - 1)
    }
    const data = (await api.get(`contracts/verify_document_transfer/${encrypted_qrcode}/`, {
        headers: {
            Authorization: ''
        }
    })).data
    const contract = data.contract
    const userInfo = data.contractor
    const document = data.document
    const document_transfer_data = data.document_transfer
    const document_cheque_data = data.document_cheques
    console.log(data);


    const doc = new jspdf()
    doc.addFileToVFS("Vazir.ttf", vazirFont);
    doc.addFont("Vazir.ttf", "Vazir", "normal");
    doc.addFileToVFS("Titr.ttf", titrFont);
    doc.addFont("Titr.ttf", "Titr", "normal");
    doc.addFileToVFS("Mitra.ttf", mitraFont);
    doc.addFont("Mitra.ttf", "Mitra", "normal");

    doc.setFont('Titr')
    doc.setFontSize(15)

    const textHeight = doc.getTextDimensions('ب').h
    let currentHeight = 5 * textHeight
    const title = contract.contractee
    doc.text(title, doc.internal.pageSize.width / 2, currentHeight, 'center')
    currentHeight += textHeight

    const qrcode = new Encoder()
    qrcode.setEncodingHint(true)
    qrcode.setErrorCorrectionLevel(ErrorCorrectionLevel.H)
    qrcode.write(`https://arjanpeyman.ir/verify/${document_transfer_data.qrcode}`)
    qrcode.make()
    doc.addImage(qrcode.toDataURL(), 'gif', 10, currentHeight, 30, 30)

    doc.setFontSize(12)
    doc.text('اعلامیه', doc.internal.pageSize.width / 2, currentHeight, 'center')
    currentHeight += 2 * textHeight

    doc.setFont('Mitra')
    doc.setFontSize(12)
    const contractorName = userInfo.name
    doc.text(contractorName, 200, currentHeight, 'right')
    currentHeight += textHeight

    let contractTitle = 'قرارداد:  '
    contractTitle += 'شماره  ' + toFarsiDigits(contract.number)
    contractTitle += '  تاریخ  ' + gregorianToJalali(contract.date)
    doc.text(contractTitle, 200, currentHeight, 'right')
    currentHeight += textHeight

    const subject = toFarsiDigits(contract.subject)
    doc.text(subject, 200, currentHeight, 'right')
    currentHeight += textHeight


    if (document_transfer_data.request_remark !== null) {
        let requestTitle = toFarsiDigits(document_transfer_data.request_remark)
        doc.text(requestTitle, 200, currentHeight, 'right')
        currentHeight += textHeight
    }

    let documentNumber = 'شماره سند:  ' + toFarsiDigits(document.number)
    documentNumber += '       تاریخ:  ' + gregorianToJalali(document.date)
    doc.text(documentNumber, 200, currentHeight, 'right')
    currentHeight += textHeight

    const description = 'شرح سند:  ' + document_transfer_data.document_remark
    doc.text(description, 200, currentHeight, 'right')
    currentHeight += textHeight

    if (document_transfer_data.serial_number !== '0') {
        let text = 'سریال اسناد خزانه:  ' + toFarsiDigits(document_transfer_data.serial_number)
        text += '    نوع اسناد خزانه:  ' + toFarsiDigits(document_transfer_data.treasury_document_title)
        text += '    تاریخ سررسید:  ' + gregorianToJalali(document_transfer_data.expiry_date)
        text += '    درصد حفظ قدرت خرید:  ' + toFarsiDigits(document_transfer_data.benefit_percent)
        doc.text(text, 200, currentHeight, 'right')
        currentHeight += textHeight

        text = 'تاریخ محاسبه حفظ قدرت خرید پیمانکار:  ' + gregorianToJalali(document_transfer_data.invoice_date)
        text += '       بازه زمانی:  ' + toFarsiDigits(document_transfer_data.day) + ' روز'
        doc.text(text, 200, currentHeight, 'right')
        currentHeight += textHeight

        text = 'تاریخ محاسبه حفظ قدرت خرید مالیات بر ارزش افزوده:  ' + gregorianToJalali(document_transfer_data.value_added_tax_reference_date)
        text += '       بازه زمانی:  ' + toFarsiDigits(document_transfer_data.value_added_tax_day) + ' روز'
        doc.text(text, 200, currentHeight, 'right')
        currentHeight += textHeight

        text = 'تاریخ محاسبه حفظ قدرت خرید بیمه:  ' + gregorianToJalali(document_transfer_data.insurance_reference_date)
        text += '       بازه زمانی:  ' + toFarsiDigits(document_transfer_data.insurance_day) + ' روز'
        doc.text(text, 200, currentHeight, 'right')
        currentHeight += textHeight
    }
    let text = ''
    if (document_transfer_data.back_prepayment_amount !== 0) {
        text = 'تسویه پیش پرداخت: ' + toFarsiDigits(thousandsSeparate(document_transfer_data.back_prepayment_amount))
        doc.text(text, 200, currentHeight, 'right')
        currentHeight += textHeight
    }
    if (document_transfer_data.back_prepayment_amount !== 0 && document_transfer_data.prepayment_sum !== 0) {
        text = 'مانده پیش پرداخت: ' + toFarsiDigits(thousandsSeparate(document_transfer_data.prepayment_sum))
        doc.text(text, 200, currentHeight, 'right')
        currentHeight += textHeight
    }
    let body = [[
        toFarsiDigits(thousandsSeparate(document_transfer_data.amount)),
        toFarsiDigits(thousandsSeparate(document_transfer_data.value_added_tax)),
        toFarsiDigits(thousandsSeparate(document_transfer_data.insurance_amount)),
        // Sum of the above three
        toFarsiDigits(thousandsSeparate(document_transfer_data.amount + document_transfer_data.value_added_tax + document_transfer_data.insurance_amount)),

        toFarsiDigits(thousandsSeparate(document_transfer_data.deposit_amount)),
        toFarsiDigits(thousandsSeparate(document_transfer_data.insurance_deduction_amount)),
        toFarsiDigits(thousandsSeparate(document_transfer_data.other_deduction_amount)),
        // Sum of the above three
        toFarsiDigits(thousandsSeparate(document_transfer_data.deposit_amount + document_transfer_data.insurance_deduction_amount + document_transfer_data.other_deduction_amount)),

        toFarsiDigits(thousandsSeparate((document_transfer_data.amount + document_transfer_data.value_added_tax + document_transfer_data.insurance_amount) - (document_transfer_data.deposit_amount + document_transfer_data.insurance_deduction_amount + document_transfer_data.other_deduction_amount))),
    ].reverse()]

    if (document_transfer_data.interest_amount !== 0 | document_transfer_data.deposit_interest_amount !== 0 | document_transfer_data.transfer_insurance_interest_amount !== 0 | document_transfer_data.insurance_interest_amount !== 0 | document_transfer_data.insurance_deduction_interest_amount !== 0 | document_transfer_data.value_added_tax_interest !== 0 | document_transfer_data.sum_interest_amount !== 0) {
        body.push([
            'حفظ قدرت خرید',
            toFarsiDigits(thousandsSeparate(document_transfer_data.interest_amount)),
            toFarsiDigits(thousandsSeparate(document_transfer_data.value_added_tax_interest)),
            toFarsiDigits(thousandsSeparate(document_transfer_data.insurance_interest_amount)),
            // Sum of the above three
            toFarsiDigits(thousandsSeparate(document_transfer_data.interest_amount + document_transfer_data.value_added_tax_interest + document_transfer_data.insurance_interest_amount)),

            toFarsiDigits(thousandsSeparate(document_transfer_data.deposit_interest_amount)),
            toFarsiDigits(thousandsSeparate(document_transfer_data.insurance_deduction_interest_amount)),
            toFarsiDigits(thousandsSeparate(document_transfer_data.other_deduction_interest_amount)),
            // Sum of the above three
            toFarsiDigits(thousandsSeparate(document_transfer_data.deposit_interest_amount + document_transfer_data.insurance_deduction_interest_amount + document_transfer_data.other_deduction_interest_amount)),

            toFarsiDigits(thousandsSeparate((document_transfer_data.interest_amount + document_transfer_data.value_added_tax_interest + document_transfer_data.insurance_interest_amount) - (document_transfer_data.deposit_interest_amount + document_transfer_data.insurance_deduction_interest_amount + document_transfer_data.other_deduction_interest_amount))),
        ].reverse())
        body.push([
            'جمع',
            toFarsiDigits(thousandsSeparate(document_transfer_data.amount + document_transfer_data.interest_amount)),
            toFarsiDigits(thousandsSeparate(document_transfer_data.value_added_tax + document_transfer_data.value_added_tax_interest)),
            toFarsiDigits(thousandsSeparate(document_transfer_data.insurance_amount + document_transfer_data.insurance_interest_amount)),
            // Sum of the above three
            toFarsiDigits(thousandsSeparate(document_transfer_data.amount + document_transfer_data.interest_amount + document_transfer_data.value_added_tax + document_transfer_data.value_added_tax_interest + document_transfer_data.insurance_amount + document_transfer_data.insurance_interest_amount)),

            toFarsiDigits(thousandsSeparate(document_transfer_data.deposit_amount + document_transfer_data.deposit_interest_amount)),
            toFarsiDigits(thousandsSeparate(document_transfer_data.insurance_deduction_amount + document_transfer_data.insurance_deduction_interest_amount)),
            toFarsiDigits(thousandsSeparate(document_transfer_data.other_deduction_amount + document_transfer_data.other_deduction_interest_amount)),
            // Sum of the above three
            toFarsiDigits(thousandsSeparate(document_transfer_data.deposit_amount + document_transfer_data.deposit_interest_amount + document_transfer_data.insurance_deduction_amount + document_transfer_data.insurance_deduction_interest_amount + document_transfer_data.other_deduction_amount + document_transfer_data.other_deduction_interest_amount)),

            toFarsiDigits(thousandsSeparate(((document_transfer_data.amount + document_transfer_data.value_added_tax + document_transfer_data.insurance_amount) - (document_transfer_data.deposit_amount + document_transfer_data.insurance_deduction_amount + document_transfer_data.other_deduction_amount)) + ((document_transfer_data.interest_amount + document_transfer_data.value_added_tax_interest + document_transfer_data.insurance_interest_amount) - (document_transfer_data.deposit_interest_amount + document_transfer_data.insurance_deduction_interest_amount + document_transfer_data.other_deduction_interest_amount)))),
        ].reverse())
    }

    doc.autoTable({
        styles: { font: "Mitra", halign: 'center', valign: 'middle', lineWidth: 0.5, lineColor: 0 },
        head: [[
            ' ',
            'کارکرد',
            'مالیات بر ارزش افزوده',
            'بیمه تامین کارفرما',
            'جمع',
            'سپرده',
            'پرداختی به بیمه',
            // If deduction title is not empty or is null write the following, else write سایر کسورات
            document_transfer_data.other_deduction_title ? document_transfer_data.other_deduction_title : 'سایر کسورات',
            'جمع کسورات',
            'جمع پرداختی',
        ].reverse()],
        body: body,
        margin: { top: currentHeight, left: 10, right: 10 },
        theme: 'grid',
        headStyles: { font: 'Mitra', fontSize: 10, halign: 'center', fillColor: 255, textColor: 0, fontStyle: 'normal' },
        bodyStyles: { font: 'Mitra', fontSize: 10, halign: 'center', fillColor: 255, textColor: 0, fontStyle: 'normal' },
    })
    currentHeight = doc.autoTable.previous.finalY + textHeight

    const copyright = 'سامانه ارجان پیمان - شرکت ارجان آرایه پویا'
    doc.text(copyright, 200, currentHeight, 'right')
    currentHeight += 3 * textHeight
    currentHeight = doc.autoTable.previous.finalY + textHeight


    if (document_cheque_data.length > 0) {
        doc.setFont('Titr')
        doc.setFontSize(12)
        let text = 'چک های صادر شده'
        doc.text(text, doc.internal.pageSize.width / 2, currentHeight, 'center')
        currentHeight += textHeight


        doc.autoTable({
            styles: { font: "Mitra", halign: 'center', valign: 'middle', lineWidth: 0.5, lineColor: 0 },
            head: [[
                'ردیف',
                'شماره چک',
                'تاریخ صدور',
                'تاریخ وصول',
                'مبلغ',
                'گیرنده',
                'شماره حساب',
                'شناسه پرداخت',
            ].reverse()],
            body: document_cheque_data.map((item, index) => [toFarsiDigits(index + 1), toFarsiDigits(item.number), gregorianToJalali(item.cheque_date), gregorianToJalali(item.cheque_collected_date), toFarsiDigits(thousandsSeparate(item.amount)), toFarsiDigits(item.receiver), toFarsiDigits(item.account_number), toFarsiDigits(item.transaction_number)].reverse()),
            margin: { left: 10, right: 10 },
            startY: currentHeight,
            theme: 'grid',
            headStyles: { font: 'Mitra', fontSize: 10, halign: 'center', fillColor: 255, textColor: 0, fontStyle: 'normal' },
            bodyStyles: { font: 'Mitra', fontSize: 10, halign: 'center', fillColor: 255, textColor: 0, fontStyle: 'normal' },
        })

        doc.setFont('Mitra')
        currentHeight = doc.autoTable.previous.finalY + textHeight
        text = 'جمع مبالغ چک های صادر شده: ' + toFarsiDigits(thousandsSeparate(document_cheque_data.reduce((acc, item) => acc + item.amount, 0))) + ' ریال'
        doc.text(text, 200, currentHeight, 'right')
        currentHeight += textHeight
    }
    currentHeight = doc.autoTable.previous.finalY + textHeight
    currentHeight += 2 * textHeight

    addPdfFooter(doc)
    var string = doc.output('datauristring');
    var iframe = "<iframe width='100%' height='100%' margin='0' src='" + string + "'></iframe>"
    window.document.open();
    window.document.write(iframe);
    window.document.close();
}

const DocumentTransferVerifyPage = () => {
    const { qrcode } = useParams()
    useEffect(() => {
        printDocumentTransfer(qrcode)
    }, [qrcode])
    return <></>
}

export default DocumentTransferVerifyPage